import {} from 'googlemaps';
import {
  Directive,
  ElementRef,
  EventEmitter,
  OnInit,
  Output,
  NgZone,
} from '@angular/core';
import { MapsAPILoader } from '@agm/core';

@Directive({
  selector: '[appPlaceLookUp]',
})
export class PlaceLookUpDirective implements OnInit {
  @Output()
  inSelect: EventEmitter<any> = new EventEmitter();

  private element: HTMLInputElement;

  constructor(
    el: ElementRef,
    private mapsAPILoader: MapsAPILoader,
    private ngZone: NgZone
  ) {
    this.element = el.nativeElement;
  }

  ngOnInit() {
    // load Places Autocomplete
    const options = {
      componentRestrictions: {
        country: 'AU',
      },
    };
    this.mapsAPILoader.load().then(() => {
      const autocomplete = new google.maps.places.Autocomplete(this.element, options);
      autocomplete.addListener('place_changed', () => {
        this.ngZone.run(() => {
          // get the place result
          const place: google.maps.places.PlaceResult = autocomplete.getPlace();
          // this.element.value = place.formatted_address;
          this.inSelect.emit(place);

          if (place.geometry === undefined || place.geometry === null) {
            return;
          }
        });
      });
    });
  }
}
